import React, { useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { networksSelector, userSelector } from '../../redux/selectors';

const Home = () => {
  const networksStore = useSelector(networksSelector);
  const { networks, active } = networksStore;
  const user = useSelector(userSelector);

  const pathname = useMemo(() => {
    if (user?.isOnlyAlly) {
      return '/settings/my-networks';
    }

    if (Object.keys(networks).length) {
      const key = active || Object.keys(networks)[0];
      const activeNetwork = networks[key];

      if (activeNetwork?.connect?.hasAccess) {
        return `/networks/${activeNetwork.slug}/home`;
      }

      // if has job board, go to dashboard
      if (activeNetwork?.features?.includes?.('job_board')) {
        return `/networks/${activeNetwork.slug}/dashboard`;
      }

      if (activeNetwork?.isCompany) {
        return `/networks/${activeNetwork.slug}/company-profile/${activeNetwork.organization.id}-${activeNetwork.organization.slug}`;
      }

      // If user is managing an organization, go to the organization profile
      if (Object.keys(activeNetwork.isOrganizationManager).length) {
        const organizationKey = Object.keys(activeNetwork.isOrganizationManager)[0];
        const organization = activeNetwork.isOrganizationManager[organizationKey];
        return `/networks/${activeNetwork.slug}/companies/${organization.slug}`;
      }
    }

    return `/settings/account-my-profile`;
  }, [active, networks, user]);

  return <Redirect to={{ pathname }} />;
};

export default Home;
